export default __webpack_public_path__ + "static/media/logo-trans-2.14e4f057.png";